/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { CommonService } from '../services/common.service';

@Component({
  selector: 'client-id-renderer',
  templateUrl: './clientid-renderer.component.html',
  styles: [
    `
      .integration-radio-btn {
        position: relative;
        top: -5px !important;
        right: 5px;
      }
      .clientId-navigation-container-ellipsis {
        width: 16%;
      }
    `
  ]
})
export class ClientIDRendererComponent implements ICellRendererAngularComp {
  public params: any;
  public hasChallengeIconBadge: any = false;
  public challengeProgramCode = '';

  constructor(public commonService: CommonService) {}

  public agInit(params: any): void {
    this.params = params;
  }

  public refresh(): boolean {
    return false;
  }

  public getTranslationWithKey(key: string) {
    return this.commonService.getTranslatedVal(key);
  }

  public onClientIdClick() {
    localStorage.setItem('PlannedManagerActionType', this.params.data.updateType || '');
    this.commonService.redirectItem(this.params.value, 'DistributorSupport');
  }

  public onAnalyticsClick() {
    this.commonService.redirectItem(this.params.value, 'Analytics');
  }

  public onGenClick() {
    this.commonService.redirectItem(this.params.value, 'Genealogy');
  }

  public onOrdersClick() {
    this.commonService.redirectItem(this.params.value, 'Orders');
  }

  public integrationLogRowSelected(rowData: any) {
    this.params.context.parentContext.integrationRowSelected(rowData);
  }

  public onTieredCompClick() {
    this.commonService.redirectItem(this.params.value, 'TieredCompensations');
  }

  public onPaymentsClick() {
    this.commonService.redirectItem(this.params.value, 'Payments');
  }

  public getClientIdWithName(param: any) {
    let name: any;
    for (let i = 0; i < param.colDef.withName.split('.').length; i++) {
      if (i == 0) {
        name = param.data[param.colDef.withName.split('.')[i]];
      } else {
        name = name[param.colDef.withName.split('.')[i]];
      }
    }
    return name + ' (' + param.value + ')';
  }
}
